export default getText => key =>
  ({
    myAccount: getText('My Account', 'Layout_Profile'),
    updatePicture: getText('Update picture', 'Layout_Profile'),
    language: getText('Language', 'Layout_Profile'),
    logout: getText('Logout', 'Layout_Profile'),
  }[key])
